module.exports = __webpack_public_path__ + "static/media/memories_13.57ee8d22.jpg";